import React, { useEffect, useState } from 'react';
import { Button } from './Button';

export function ButtonExample(): JSX.Element {
  const [loading, setLoading] = useState(false);

  function handleOnClick(): void {
    setLoading(true);
  }

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [loading]);

  return (
    <>
      <div className="styleguide__buttons">
        <Button title="Default button" />
        <Button title="Primary button" type="primary" />
        <Button title="Link button" type="link" />
      </div>
      <div style={{ margin: '16px 0px' }}>
        <Button title="Loading Button" type="primary" onClick={handleOnClick} loading={loading} />
      </div>
      <div style={{ margin: '16px 0px' }}>
        <Button title="Loading Button" type="primary" success />
      </div>
    </>
  );
}
